module.exports = require("./es-GT.js");